<template>
  <div class="comment-reply">
    <ul class="comment-reply-main">
      <li v-for="item in reply" :key="item.comment_ID + 'reply'">
        <h6 class="comment-reply-title">
          {{
            $t("comment.reply", {
              name:
                current_theme == "athena" && blogname ? blogname : "Merchant",
            })
          }}
        </h6>
        <p class="time">{{ item.comment_date }}</p>
        <p>{{ item.content }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ["reply"],
  data() {
    return {
      current_theme: null,
      blogname: null,
    };
  },
  beforeMount() {
    this.current_theme = this.$store.state?.options?.theme?.name;
    this.blogname = this.$store.state?.options?.base?.blogname;
  },
};
</script>
<style scoped lang='scss'>
.comment-reply {
  width: 100%;
  padding: 0 12px 30px;
  .comment-reply-main {
    margin: 0;
    padding: 0;
    li {
      list-style: none;
      border-top: 1px solid #dddddd;
      margin-top: 11px;
      padding-top: 12px;
      .comment-reply-title {
        font-size: 16px;
        margin: 0px 0px 6px;
        font-family: NunitoSans-Regular !important;
        font-weight: 600;
        color: #222222;
        line-height: 22px;
      }
      .time {
        margin-top: 0;
        color: #999;
        font-size: 12px;
        font-family: NunitoSans-Regular !important;
      }
      p {
        margin-top: 12px;
        list-style: none;
        font-size: 14px;
        font-weight: 400;
        color: #222222;
        line-height: 18px;
      }
    }
  }
}
</style>